<template>
    <div style="margin: 10px; margin-top: 0px;">
        <div class="container-fluid">
            <div class="row" style="height: 200px;">
                <a v-if="isInitial" @click="downloadTemplate()" style="cursor: pointer;">{{$Jed.firstUpperTranslate('download template')}}</a>
                <form id="orderItemsUpload" v-if="isInitial || isSaving" style="padding-top: 5px;"
                    :action="$root.front_end_configs.router_url+'fileupload'" method="post" enctype="multipart/form-data"> 
                    <!--action: defines where the data gets sent-->
                    <!--method: defines how data is sent-->
                    <div class="ddbox">
                        <input type="file" accept=".csv,text/csv" id="file" name="fileToLoad" @change="selectFile" ref="file" class="input-file" :disabled="isSaving" />
                        <p v-if="isInitial" style="padding: 65px 0px 0px 0px; font-weight: 600;">{{$Jed.firstUpperTranslate('Drag your file here or click to browse')}}</p>
                        <p v-if="isInitial" style="padding: 0px 25px 0px; font-size: .9em;">{{$Jed.firstUpperTranslate('upload instructions')}}</p>
                        <p v-if="isSaving">{{file.name}}</p>
                    </div>
                    <button type="submit" :disabled="isSyncing" v-if="file" class="btn btn-primary-default" style="margin-top: 15px; margin-right: 15px; float: right;">
                        {{$Jed.firstUpperTranslate('send')}}
                    </button>
                </form>
                <div v-if="isSuccess">
                    <h3> {{$Jed.firstUpperTranslate('file uploaded successfully')}} </h3>
                    <ul class="list-unstyled">{{uploadedFile}}</ul>

                    <textarea readonly v-if="uploadWarning.length>0" 
                        style="margin: 10px 0px; white-space: normal; overflow-y: scroll; height: 90px; width: 100%; resize: none; background-color: #eee; font-family: monospace; font-size: small;">
                        {{$Jed.firstUpperTranslate('warning')+': \n'}} {{ uploadWarning }}
                    </textarea>
                    <p style="margin: 10px 0px 10px;">
                        <a @click="reset()" style="cursor: pointer;">{{$Jed.firstUpperTranslate('Upload again')}}</a>
                    </p>
                </div>
                <div v-if="isFailed">
                    <h3>{{$Jed.firstUpperTranslate('warning')}}</h3>
                    <textarea readonly style="margin: 10px 0px; white-space: normal; overflow-y: scroll; height: 90px; width: 100%; resize: none; background-color: #eee; font-family: monospace; font-size: small;">
                        {{ uploadError }}
                    </textarea>
                    <p style="margin: 10px 0px 10px;">
                        <a @click="reset()" style="cursor: pointer;">{{$Jed.firstUpperTranslate('Try again')}}</a>
                    </p>
                </div>
            </div>
            <!--Loader per l'attesa del caricamento-->
            <div v-if="loadingfile" class="sk-cube-grid" style="position: absolute; top: 10px; right: 25px; left: 0px;">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
            <div class="row" style="height: 20px;"></div>
        </div>    
    </div>    
</template>

<script>

import { eventBus } from "../../eventbus";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
    props: {
        oid: String
    },
    data: function () {
        var vm = this;
        return {
            labels: {
                closeBtnLbl: vm.$Jed.firstUpperTranslate('close'),
            },
            file: null,
            currentStatus: null,
            uploadedFile: null,
            uploadError: '',
            ordId: null,
            uploadWarning: '',
            loadingfile: false,
            isSyncing: true,
            formData: new FormData(),
            knownMessages: [
                "unknow upload type",
                "order id not valid",
                "order not found",
                "fetch order error",
                "file not found or not readable",
                "file not found",
                "file is empty",
                "file read error",
                "no valid product codes found in file",
                "fetch order rows error",
                "fetch products properties error",
                "delete rows error",
                "product id not specified",
                "quantity not specified",
                "quantity not a number",
                "quantity is 0 or less",
                "unknow product",
                "insert row error",
                "CSV File must have 3 columns",
                "product already in the order"
            ]
        }
    },
    created: function(){
        var vm = this;
        eventBus.$on("gotChanges",()=>{
            var reg_orders = vm.$root.dbRegistry.getCollection('orders'),
                order = vm.$root.shopCartData ? reg_orders.find({'$loki': vm.$root.shopCartData.$loki}) : '';
            
            console.log("gotChanges from UploadFile!")
            console.log(order)
            
            if(order && order[0]){
                vm.ordId = order[0].id;

                console.log('ID ritornato dalla sync: ', vm.ordId)

                vm.formData.append('cmd', 'data.io.Upload')
                vm.formData.append('cmdArgs', JSON.stringify({
                    'type': 'orderItems',
                    'recordId': vm.ordId, 
                    'lang': vm.$Configs.siglaLingua,
                    'defaultLang': vm.$Configs.defaultLang
                }))
                vm.formData.append('file', vm.file)
                vm.loadingfile = false
                vm.isSyncing = false
            }else{
                vm.ordId = null;
            }
        })
    },
    mounted: function(){
        this.reset();
        var vm = this;
        eventBus.$on('closeUploadModalEvent',()=>{
            vm.closeClick();
        })
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
        selectFile(){
            console.log('nuovo file!!')
            var vm = this;
            this.isSyncing = true
            var fileInput = document.getElementById('file')
            var filePath = fileInput.value;
            // Allowing file type 
            var allowedExtensions = /(\.csv)$/i;
            var idToBePassed;
              
            if (!allowedExtensions.exec(filePath)) {
                eventBus.$emit('alert', {
                    message: this.$Jed.firstUpperTranslate('this type of file is not allowed'), 
                    type: "warning" 
                })
                fileInput.value = ''; 
                this.reset()
            }else{
                console.log("Extension allowed! :-)")
                this.file = this.$refs.file.files[0]
                this.currentStatus = STATUS_SAVING;              

                //quando apro la finestra di upload l'id dell'ordine mi viene sempre passato come props 
                //(sia se l'ordine esisteva già, sia se è un nuovo ordine)
                //se la lascio aperta dopo il primo caricamento, devo usare il nuovo id ordine risposto dal service
                if(vm.ordId){
                    console.log('id ordine passato da gotChanges')
                    idToBePassed = vm.ordId;
                }else{
                    console.log('id ordine passato da componente superiore')
                    idToBePassed = this.oid;
                }

                console.log('selectFile > idToBePassed: ', idToBePassed)

                if(idToBePassed<0){
                    console.log("new order")
                    vm.loadingfile = true
                    vm.isSyncing = true
                    console.log("going to saveDraft...")
                    this.$root.saveDraft();
                }else{
                    console.log("order already existing!")
                    vm.loadingfile = true
                    vm.isSyncing = false

                    vm.formData.append('cmd', 'data.io.Upload')
                    vm.formData.append('cmdArgs', JSON.stringify({
                        'type': 'orderItems',
                        'recordId': idToBePassed, 
                        'lang': this.$Configs.siglaLingua,
                        'defaultLang': this.$Configs.defaultLang
                    }))
                    vm.formData.append('file', this.file)
                    vm.loadingfile = false
                }

                orderItemsUpload.onsubmit = async (e) => {
                    e.preventDefault();
                    vm.loadingfile = true;
                    vm.isSyncing = true;
                    console.log("LOADING FILE: ", vm.loadingfile)
                    fetch(vm.$root.front_end_configs.router_url+'fileupload', {
                        method: 'POST',
                        body: vm.formData,
                        headers: {
                            'Authorization': localStorage.getItem("token")
                        }
                    })
                    .then(response => {
                        return response.json();
                    })
                    .then(data=>{
                        console.log(data)
                        var uploadFailed = '',
                            badFile;
                        vm.uploadError = ''
                        vm.uploadWarning = ''
                        vm.loadingfile = false;
                        vm.isSyncing = false;

                        console.log("LOADING FILE THEN: ", vm.loadingfile)
                        
                        if(data.error){
                            console.log('error!')
                            vm.uploadError = vm.translateMessage(data.error)+'\n'
                            vm.currentStatus = STATUS_FAILED;
                        }else if(data.war && data.war.length>0){
                            console.log('warning!')
                            for(var r in data.war){
                                if(data.war[r]){
                                    if(data.war[r].warn.includes("CSV File must have 3 columns")){
                                        badFile = true;
                                    }
                                    var twms = vm.translateMessage(data.war[r].warn)
                                    uploadFailed += vm.$Jed.firstUpperTranslate('row')+': '+data.war[r].row+' - '+vm.$Jed.firstUpperTranslate('code')+': '+data.war[r].id+' ('+twms+')\n'
                                }
                            }
                            
                            if(uploadFailed.length>0){
                                if(badFile){
                                    vm.uploadError = vm.$Jed.firstUpperTranslate('CSV File must have 3 columns');
                                    vm.currentStatus = STATUS_FAILED;
                                }else{
                                    vm.uploadWarning = uploadFailed;
                                    vm.uploadedFile = vm.file.name;
                                    vm.currentStatus = STATUS_SUCCESS;
                                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate();
                                }
                            }
                        }else{
                            console.log('no warnings, no errors')
                            vm.uploadedFile = vm.file.name;
                            vm.currentStatus = STATUS_SUCCESS;
                            if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate();
                        }
                    })
                    .catch(error=>{
                        console.log('CATCH')
                        console.log(error)
                        if(error.message == 415){ //unsupported media type
                            vm.uploadError = vm.$Jed.firstUpperTranslate('this type of file is not supported by the server');
                        }else if(error.message == 406){ //not acceptable
                            vm.uploadError = vm.$Jed.firstUpperTranslate('maximum file or filename size reached %1$s %2$s', null, {key: null, string: [vm.$root.token.upload["orderItems"].fileSize, vm.$root.token.upload["orderItems"].fileNameSize]}, null);
                        }else{
                            vm.uploadError = error
                        }
                        vm.currentStatus = STATUS_FAILED;
                        vm.loadingfile = false;
                    })
                };
            }
        },
        reset(){ 
            this.currentStatus = STATUS_INITIAL;
            this.file = "";
            this.uploadedFile = null;
            this.uploadError = "";
            this.uploadWarning = "";
            this.loadingfile = false;
            this.formData = new FormData();
        },
        wait(ms) {
            return (x) => {
                return new Promise(resolve => setTimeout(() => resolve(x), ms));
            };
        },
        closeClick(){
            if(document.getElementById("orderItemsUpload"))document.getElementById("orderItemsUpload").reset();
            this.reset();
        },
        downloadTemplate(){
            //alert('downloading template!')
            window.open(this.$root.msPath + '/'+ this.$Configs.licenseId +'/templates/order-items-upload.csv');
        },
        translateMessage(wms){
            var vm = this;
            return wms.split(',')
                .map(w => {
                const trimmed = w.trim();
                const match = vm.knownMessages.find(msg => trimmed.includes(msg));
                return match
                    ? trimmed.replace(match, vm.$Jed.firstUpperTranslate(match))
                    : trimmed;
                })
                .join(', ');
        }
    }
}
</script>

<style>
.ddbox{
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
}

.input-file{
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.ddbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}

.ddbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 65px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/others/UploadFile.vue?79ba8c18